import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';

/**
 * Create a new bout contest
 */
export async function createBout(visibility, targetStreak, invitedUsername = null) {
  const fn = httpsCallable(functions, 'createBout');
  const result = await fn({ visibility, targetStreak, invitedUsername });
  return result.data;
}

/**
 * Join an open bout (public or accepted private invitation)
 */
export async function joinBout(boutId) {
  const fn = httpsCallable(functions, 'joinBout');
  const result = await fn({ boutId });
  return result.data;
}

/**
 * Delete an unfilled bout (creator only)
 */
export async function deleteBout(boutId) {
  const fn = httpsCallable(functions, 'deleteBout');
  const result = await fn({ boutId });
  return result.data;
}

/**
 * Decline a private bout invitation (invited user only)
 */
export async function declineBout(boutId) {
  const fn = httpsCallable(functions, 'declineBout');
  const result = await fn({ boutId });
  return result.data;
}
